import { Box, Tooltip, Typography } from '@mui/material'
import AppleIcon from '@mui/icons-material/Apple'
import AdbIcon from '@mui/icons-material/Adb'
import LaptopMacIcon from '@mui/icons-material/LaptopMac'
import LaptopWindowsIcon from '@mui/icons-material/LaptopWindows'
import { useColorModeContext } from '../../context/ColorModeContext'
import { useSearchContext } from '../../context/SearchCacheContext'
import * as React from 'react'

interface Props {
  data: any
}


const getOSIcon = (osType) => {
  switch(osType?.toLowerCase()) {
    case 'android':
      return <Tooltip title="Android"><AdbIcon fontSize="small" /></Tooltip>;
    case 'ios':
      return <Tooltip title="iOS"><AppleIcon fontSize="small" /></Tooltip>;
    case 'macos':
      return <Tooltip title="Mac"><LaptopMacIcon fontSize="small" /></Tooltip>;
    case 'windows':
      return <Tooltip title="Windows"><LaptopWindowsIcon fontSize="small" /></Tooltip>;
  }
};


interface Props {
  data: {
    keyword: string,
    countryCode: string,
    deviceType: string,
    osType: string,
  }
}

const TrackingKeyword = ({ data }: Props ) => {
  const { mode } = useColorModeContext();
  const { country, setCountry, setInputValue } = useSearchContext();

  const handleLinkClick = () => {
    setInputValue('rankerfy.com')
    setCountry(country)
  };

  return (
      <Box sx={{ mt: 1.6 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Country and language */}
          <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {data.language && (
              <Typography
                variant="caption"
                sx={{
                  fontSize: '0.65rem',
                  lineHeight: 1,
                  position: 'absolute',
                  top: '-12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  padding: '1px 3px',
                  borderRadius: '2px'
                }}
              >
                {data.language.toUpperCase()}
              </Typography>
            )}
            <Tooltip title={data.country || "Global"}>
              <img
                src={`https://flagcdn.com/${data.country?.toLowerCase() || 'es'}.svg`}
                width={24}
                height={18}
                style={{ marginTop: '3px' }}
              />
            </Tooltip>
          </Box>
          {getOSIcon(data.os)}
          <Typography variant="body2" sx={{ fontWeight: 'medium', flex: 1 }}>
            {data.keyword}
          </Typography>
        </Box>
      </Box>

  )
}

export default TrackingKeyword;